import { render } from "./Icons.vue?vue&type=template&id=41b57336"
import script from "./Icons.vue?vue&type=script&lang=js"
export * from "./Icons.vue?vue&type=script&lang=js"
script.render = render

export default script